/**
 * collection-scroll-restore.js
 * Collection page ("Load more" / infinite scroll): when the shopper opens a product and comes back
 * (browser back / swipe back), re-load the pages they had loaded and put them back at the
 * product they clicked, instead of dropping them at the top with only the first page.
 *
 * - Saves { scroll position, how many products were loaded, the clicked product link, its on-screen offset }
 *   in sessionStorage, keyed by the collection URL (so filters/sort are respected).
 * - Restores only on a back/forward navigation. If the browser restores the page itself from its
 *   back/forward cache (event.persisted), nothing is done.
 * - Uses the Ajaxinate instance the theme already created (window.endlessScroll) to fetch the pages,
 *   so product cards are initialised exactly like a normal "load more".
 */
(function () {
  "use strict";

  var KEY = "hom_coll_state:" + location.pathname + location.search;
  var MAX_AGE = 30 * 60 * 1000; // 30 min
  var GRID = "#product-grid";

  function grid() { return document.querySelector(GRID); }
  function count() { var g = grid(); return g ? g.querySelectorAll(":scope > li").length : 0; }
  function read() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch (e) { return null; }
  }
  function write(state) {
    try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }

  if (!grid()) return;
  try { history.scrollRestoration = "manual"; } catch (e) {}

  // ---------- save ----------
  var clicked = null;
  function snapshot() {
    var s = { t: Date.now(), y: Math.round(window.scrollY), n: count() };
    if (clicked && document.contains(clicked)) {
      s.href = clicked.getAttribute("href");
      s.top = Math.round(clicked.getBoundingClientRect().top);
    }
    write(s);
  }
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest(GRID + ' a[href*="/products/"]');
    if (a) { clicked = a; snapshot(); }
  }, true);
  window.addEventListener("pagehide", snapshot);
  document.addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") snapshot(); });

  // ---------- restore ----------
  var nav = (performance.getEntriesByType && performance.getEntriesByType("navigation")[0]) || {};
  if (nav.type !== "back_forward") { try { sessionStorage.removeItem(KEY); } catch (e) {} return; }

  var state = read();
  if (!state || Date.now() - state.t > MAX_AGE) return;

  document.documentElement.classList.add("coll-restoring");
  var safety = setTimeout(finish, 8000); // never leave the page hidden

  function finish() {
    clearTimeout(safety);
    var target = null;
    if (state.href) {
      var links = grid().querySelectorAll('a[href]');
      for (var i = 0; i < links.length; i++) { if (links[i].getAttribute("href") === state.href) { target = links[i]; break; } }
    }
    if (target && typeof state.top === "number") {
      window.scrollTo(0, target.getBoundingClientRect().top + window.scrollY - state.top);
    } else {
      window.scrollTo(0, state.y || 0);
    }
    document.documentElement.classList.remove("coll-restoring");
    // lazy images / late layout shifts keep moving the page for a moment: re-align until it settles,
    // but stop as soon as the shopper scrolls themselves
    var userMoved = false, ticks = 0;
    function stop() { userMoved = true; }
    ["wheel", "touchstart", "keydown", "mousedown"].forEach(function (ev) { window.addEventListener(ev, stop, { passive: true, once: true }); });
    var settle = setInterval(function () {
      ticks++;
      if (userMoved || ticks > 24) return clearInterval(settle);   // ~6s max
      if (target && typeof state.top === "number") {
        var delta = target.getBoundingClientRect().top - state.top;
        if (Math.abs(delta) > 4) window.scrollBy(0, delta);
      }
    }, 250);
  }

  function nextLink() {
    var p = document.querySelector("#AjaxinatePagination");
    return p ? p.querySelector("a[href]") : null;
  }

  function loadUntilEnough(es) {
    if (count() >= state.n) return finish();
    var link = nextLink();
    if (!link) return finish();
    es.nextPageUrl = link.href;
    es.loadMore();
  }

  function start() {
    var es = window.endlessScroll;
    if (!es || typeof es.loadMore !== "function") return finish();
    // chain after the theme's own callback; each loaded page triggers the next one
    var original = es.settings.callback;
    es.settings.callback = function () {
      if (typeof original === "function") original.apply(this, arguments);
      setTimeout(function () { loadUntilEnough(es); }, 0);
    };
    // stop the scroll listener from racing with us while we load
    if (es.settings.method === "scroll") es.removeScrollListener();
    loadUntilEnough(es);
    // when done, hand control back to the theme's own scroll/click handling
    var wait = setInterval(function () {
      if (!document.documentElement.classList.contains("coll-restoring")) {
        clearInterval(wait);
        es.settings.callback = original;
        if (es.paginationElement && es.paginationElement.querySelector("a")) es.initialize();
      }
    }, 200);
  }

  function boot() {
    var tries = 0;
    (function waitForAjaxinate() {
      if (window.endlessScroll || tries++ > 30) return start();
      setTimeout(waitForAjaxinate, 100);
    })();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
